import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_TELEFON_AKTUALISIEREN_ADMIN = '[BenutzerverwaltungModul] PostBenutzerTelefonAktualisierenAdmin laden';
export const POST_BENUTZER_TELEFON_AKTUALISIEREN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerTelefonAktualisierenAdmin ausführen';
export const POST_BENUTZER_TELEFON_AKTUALISIEREN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerTelefonAktualisierenAdmin laden erfolgreich';
export const POST_BENUTZER_TELEFON_AKTUALISIEREN_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerTelefonAktualisierenAdmin Ladefehler';
export const POST_BENUTZER_TELEFON_AKTUALISIEREN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerTelefonAktualisierenAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerTelefonAktualisierenAdminAction implements Action {
    readonly type = POST_BENUTZER_TELEFON_AKTUALISIEREN_ADMIN;
        constructor(public benutzerTelefonRequest: api.BenutzerTelefonRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefonAktualisierenAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_TELEFON_AKTUALISIEREN_ADMIN_AUSFUEHREN;
        constructor(public benutzerTelefonRequest: api.BenutzerTelefonRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefonAktualisierenAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_TELEFON_AKTUALISIEREN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerTelefonRequest: api.BenutzerTelefonRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefonAktualisierenAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_TELEFON_AKTUALISIEREN_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerTelefonRequest: api.BenutzerTelefonRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefonAktualisierenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_TELEFON_AKTUALISIEREN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerTelefonAktualisierenAdminActions =
    PostBenutzerTelefonAktualisierenAdminAction
    | PostBenutzerTelefonAktualisierenAdminAusfuehrenAction
    | PostBenutzerTelefonAktualisierenAdminErfolgreichAction
    | PostBenutzerTelefonAktualisierenAdminFehlerAction
    | PostBenutzerTelefonAktualisierenAdminNichtAusgefuehrtAction
    ;
